// Reshapes authz.* MenuItemAccessDTOs into the flat nav-item shape the navigation components
// expect: Navbar.jsx filters on `parentId`/`active`, NavbarItem.js translates `name` itself and
// shows a dropdown when `hasChildren` is true. hasChildren comes from the backend, which knows
// the full visible tree. Used for both the public menu and the logged-in (per-company) menu.

// Stable reference for "no items", so storing an empty menu doesn't hand selectors a new []
// each time (which re-triggers effects that depend on the menu).
export const EMPTY_ARRAY = [];

export const mapAuthzMenuItemsToNavItems = (items) => {
	if (!items || items.length === 0) {
		return EMPTY_ARRAY;
	}

	return items.map((item) => ({
		id: item.menuItemId,
		parentId: item.parentMenuItemId,
		to: item.routePath,
		// The navbar draws only active items; ProtectedRoute still allows every route in the
		// list, so show_in_menu = false keeps a page reachable but out of the bar.
		active: item.showInMenu !== false,
		name: item.labelKey,
		icon: item.icon,
		landingPriority: item.landingPriority,
		hasChildren: item.hasChildren,
	}));
};
